import React, { useState, useEffect } from 'react';
import { getMyAssignments } from '../../api';
import { toast } from 'react-toastify';
const BASE_URL = process.env.REACT_APP_API_URL?.replace('/api','') || 'http://localhost:5000';

const StudentAssignments = () => {
  const [assignments, setAssignments] = useState([]);

  useEffect(() => { loadAssignments(); }, []);

  const loadAssignments = async () => {
    try {
      const res = await getMyAssignments();
      setAssignments(res.data);
    } catch (err) {
      toast.error('Error loading assignments');
    }
  };

  const isOverdue = (dueDate) => {
    if (!dueDate) return false;
    return new Date(dueDate) < new Date();
  };

  return (
    <div>
      <h3 style={styles.title}>My Assignments</h3>
      {assignments.length === 0 && (
        <div style={styles.empty}>No assignments yet!</div>
      )}
      <div style={styles.grid}>
        {assignments.map(a => (
          <div key={a.id} style={{
            ...styles.card,
            borderTop: isOverdue(a.due_date) ? '4px solid #dc3545' : '4px solid #28a745'
          }}>
            <div style={styles.cardHeader}>
              <h4 style={styles.cardTitle}>{a.title}</h4>
              {isOverdue(a.due_date) && (
                <span style={styles.overdueBadge}>Overdue</span>
              )}
            </div>
            <p style={styles.subject}>{a.subject_name}</p>
            {a.description && (
              <p style={styles.description}>{a.description}</p>
            )}
            <div style={styles.infoRow}>
              {a.due_date && (
                <p style={{
                  ...styles.dueDate,
                  color: isOverdue(a.due_date) ? '#dc3545' : '#28a745'
                }}>
                  Due: {new Date(a.due_date).toLocaleDateString()}
                </p>
              )}
              {a.total_marks && (
                <p style={styles.marks}>Marks: {a.total_marks}</p>
              )}
            </div>
            {a.file_path && (
              <a href={`${BASE_URL}/uploads/${a.file_path}`}
                target="_blank" rel="noreferrer" style={styles.downloadBtn}>
                Download Assignment
              </a>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

const styles = {
  title: { color: '#1a3a5c', marginBottom: '20px' },
  empty: { textAlign: 'center', color: '#999', padding: '40px', background: 'white', borderRadius: '12px' },
  grid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: '15px' },
  card: { background: 'white', borderRadius: '12px', padding: '20px', boxShadow: '0 2px 10px rgba(0,0,0,0.08)' },
  cardHeader: { display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '8px' },
  cardTitle: { color: '#1a3a5c', margin: 0, fontSize: '15px' },
  overdueBadge: { padding: '3px 10px', background: '#f8d7da', color: '#721c24', borderRadius: '20px', fontSize: '11px' },
  subject: { color: '#0d6efd', fontSize: '13px', margin: '0 0 8px' },
  description: { color: '#666', fontSize: '13px', lineHeight: '1.5', margin: '0 0 12px' },
  infoRow: { display: 'flex', justifyContent: 'space-between', marginBottom: '12px' },
  dueDate: { fontSize: '13px', margin: 0, fontWeight: '600' },
  marks: { color: '#666', fontSize: '13px', margin: 0 },
  downloadBtn: { display: 'inline-block', padding: '8px 15px', background: '#0d6efd', color: 'white', borderRadius: '6px', fontSize: '13px', textDecoration: 'none' },
};

export default StudentAssignments;